import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DividendPayoutStatus } from './dividend.types';
import { DIVIDEND_INVALIDATION_KEYS } from './dividend-invalidation.const';

type TransitionDto = {
  date?: string;
  payoutId: string;
  status: DividendPayoutStatus;
};

export const useDividendTransitionStatus = () => {
  const { invalidateQuery } = useInvalidateQueries(...DIVIDEND_INVALIDATION_KEYS);

  const { isPending, mutate: transition } = useAppMutation<unknown, unknown, TransitionDto>(
    [QueryKey.TRANSITION_DIVIDEND_STATUS],
    {
      mutationFn: ({ payoutId, status, date }) =>
        ApiService.patch(
          { endpoint: BackendRoute.DIVIDENDS, routePath: [payoutId, 'status'] },
          { body: { date, status } },
        ),
      onSuccess: () => {
        invalidateQuery();
      },
    },
  );

  return { isPending, transition };
};
